import React from 'react'
import { Text, StyleSheet } from 'react-native'
import PropTypes from 'prop-types'

type QuestionTitleProps = {
  /** The questions title label. */
  title: string,
}

/**
 * The answers title to a question.
 * @component
 */
export const QuestionTitle = ({title}: QuestionTitleProps) => (
  <Text style={styles.container}>
    {title}
  </Text>
)

QuestionTitle.propTypes = {
  title: PropTypes.string.isRequired,
}

QuestionTitle.defaultProps = {
  title: 'What type of seating do you prefer?',
}

const styles = StyleSheet.create({
  container: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#444',
    marginTop: 10,
    marginBottom: 10,
    textAlign: 'center',
  },
})